import PropTypes from 'prop-types'
import React from 'react'
import { Header } from '../../Header'
import { Email } from '../Email'
import { Phone } from '../Phone'
import { ViberAndWhatsapp } from '../ViberAndWhatsapp'
import { PhoneVerification } from '../PhoneVerification'
import { AddPhoneBtn } from '../AddPhoneBtn'
import { SmsCode } from '../SmsCode'
import { FieldArray, getFormInitialValues, getFormValues } from 'redux-form'
import { connect } from 'react-redux'
import { RegistrationApi } from '../../../../../../Registration/api'
import { phoneValidator } from 'Core/validators'
import { setProfileUpdateError } from '../../../../../actions'
import config from 'SRC/config/config.yaml'

export class Container extends React.Component {
  state = {smsCodes: []}

  componentDidUpdate (prevProps) {
    if (this.props.isAddButtonAvailable && !prevProps.isAddButtonAvailable) {
      this.resetState()
    }
  }

  renderPhones = ({fields, smsCodes, visiblePhonesCount}) => fields.map((item, index) => {
    return [
      <div className='form-telefon form-telefon-old' key={`telefon-${index}`}>
        <div className='form-telefon__row'>
          <Phone index={index} visiblePhonesCount={visiblePhonesCount} />
          <ViberAndWhatsapp index={index} />
        </div>
        <PhoneVerification index={index} onClick={this.onVerificationClick} />
        {smsCodes.includes(index) ? <SmsCode index={index} onClick={this.onSubmitSmsCode} /> : null}
      </div>,
      index === fields.length - 1 && this.props.isAddButtonAvailable
        ? <AddPhoneBtn key='addPhoneBtn' onClick={() => fields.push()} />
        : null
    ]
  })

  onVerificationClick = async index => {
    if (!this.state.smsCodes.includes(index)) {
      try {
        await this.sendSmsCode(index)
        this.setState({...this.state, smsCodes: [...this.state.smsCodes, index]})
      } catch (e) {
        this.props.setProfileUpdateError(e.message)
      }
    }
  }

  sendSmsCode = async (index) => {
    const api = new RegistrationApi()
    const phone = this.props.phones[index] && this.props.phones[index].phone
    let error = ''
    if (phone) {
      const number = phone.replace(/ /g, '').replace(/\+/g, '')
      if (phoneValidator(number)) {
        const response = await api.sendSmsCode(number.replace(/ /g, '').replace(/\+/g, ''))
        if (response.status === RegistrationApi.responseTypes.OK) {
          if (response.statusCode && Number(response.statusCode) === RegistrationApi.statusCodes.NUMBER_ALREADY_USED) {
            error = config.updateProfileForm.errors.PHONE_ERROR
          }
        } else {
          error = config.updateProfileForm.errors.DEFAULT
        }
      } else {
        error = config.updateProfileForm.errors.DEFAULT
      }
    } else {
      error = config.updateProfileForm.errors.DEFAULT
    }
    if (error) {
      throw new Error(error)
    }
  }

  onSubmitSmsCode = e => {
    const index = Number(e.target.dataset.id)
    this.props.onPhoneSubmit({
      phone: this.props.phones[index].phone.replace(/ /g, '').replace(/\+/g, ''),
      code: this.props.phones[index].code,
      viber: Boolean(this.props.phones[index].viber),
      whatsapp: Boolean(this.props.phones[index].whatsapp)
    })
  }

  resetState = () => {
    this.setState({smsCodes: []})
  }

  render () {
    const { visiblePhonesCount } = this.props
    return [
      <Header key='header'>{config.updateProfileForm.contact.title}</Header>,
      <FieldArray key='phones' name='phones' smsCodes={this.state.smsCodes} component={this.renderPhones} visiblePhonesCount={visiblePhonesCount} />,
      <Email key='email' />
    ]
  }
}

Container.displayName = 'Contacts'

const mapStateToProps = state => {
  const props = {isAddButtonAvailable: false}
  const initValues = getFormInitialValues('update')(state)
  const actualValues = getFormValues('update')(state)
  const phones = actualValues && actualValues.phones

  if (
    initValues &&
    Array.isArray(initValues.phones) &&
    actualValues &&
    Array.isArray(phones) &&
    phones.length === initValues.phones.length
  ) {
    props.isAddButtonAvailable = true
  }
  props.phones = Array.isArray(phones) ? [...phones] : []
  props.visiblePhonesCount = props.phones.filter(phone => phone ? phone.visible : false).length
  return props
}

Container.propTypes = {
  isAddButtonAvailable: PropTypes.bool.isRequired,
  phones: PropTypes.arrayOf(PropTypes.shape({
    phone: PropTypes.string,
    code: PropTypes.string,
    viber: PropTypes.bool,
    whatsapp: PropTypes.bool
  })),
  visiblePhonesCount: PropTypes.number.isRequired,
  setProfileUpdateError: PropTypes.func.isRequired,
  onPhoneSubmit: PropTypes.func.isRequired
}

Container.defaultProps = {
  isAddButtonAvailable: false,
  phones: []
}

export default connect(mapStateToProps, {setProfileUpdateError})(Container)
